import { AppUser, IField, TOrgTag } from '@eventr/common'
import {
    ColoursObj,
    Icon,
    MainButton,
    Typography,
} from '@eventr/common-storybook'
import { Box, Checkbox, Stack } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { MemberProfilePic } from '../../../home/team/MemberProfilePic'
import i18n from '../../../i18n/i18next'
import { useBoundStore } from '../../../state/bound.store'
import { useEditSectionContext } from '../editSectionProvider'
type props = { field: IField; _id?: string }

export const AttendeesList: FC<props> = ({ field, _id }) => {
    const { getValue } = useEditSectionContext()
    const { updateValues } = useEditSectionContext()
    const { orgConfig, selectedItineraryUsers, getNameFormatted } =
        useBoundStore(
            useShallow((s) => {
                return {
                    orgConfig: s.orgConfig,
                    selectedItineraryUsers: s.selectedItineraryUsers,
                    getNameFormatted: s.getNameFormatted,
                }
            })
        )

    const [membersListSelectList, setMembersListSelectList] =
        useState<string>('[]')

    useEffect(() => {
        const initFieldValue = getValue(field, _id)
        setMembersListSelectList(JSON.stringify(initFieldValue))
    }, [field, _id, getValue])

    useEffect(() => {
        try {
            updateValues({
                value: JSON.parse(membersListSelectList),
                field: field,
                _id: _id,
            })
        } catch {}
    }, [membersListSelectList, updateValues, field, _id])

    type EditTeamMemberLineProps = {
        index: number
        selectedUserList: any[]
        user: AppUser
        inList: boolean
    }

    const EditTeamMemberLine: FC<EditTeamMemberLineProps> = ({
        index,
        selectedUserList,
        user,
        inList,
    }) => {
        return (
            <div
                key={user.id}
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'auto auto 1fr',
                    alignItems: 'center',
                    width: '100%',
                    gap: '8px',
                }}
                onClick={() => {
                    try {
                        if (inList) {
                            const tmpMembersListTemp = selectedUserList.filter(
                                (member) => {
                                    if (
                                        member.type === 'User' &&
                                        member.option === user.id
                                    ) {
                                        return false
                                    } else {
                                        return true
                                    }
                                }
                            )
                            var tmpm = JSON.parse(membersListSelectList)
                            tmpm[index].users = tmpMembersListTemp

                            setMembersListSelectList(JSON.stringify(tmpm))
                        } else {
                            var tmp = JSON.parse(membersListSelectList)
                            tmp[index].users = [
                                ...JSON.parse(membersListSelectList)[index]
                                    .users,
                                { type: 'User', option: user.id },
                            ]

                            setMembersListSelectList(JSON.stringify(tmp))
                        }
                    } catch {}
                }}
            >
                <Box>
                    <Checkbox checked={inList} color="secondary" />
                </Box>

                <Box>
                    <MemberProfilePic user={user} />
                </Box>

                <Box>
                    <Typography>{getNameFormatted(user)}</Typography>
                </Box>
            </div>
        )
    }

    function checkIfUserSelected(selectedUserList: any[], userId: number) {
        const orgUser = selectedUserList?.find((itineraryUser) => {
            if (itineraryUser.type === 'User') {
                if (itineraryUser.option === userId) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        })
        if (orgUser) {
            return true
        } else {
            return false
        }
    }

    function checkIfDepartmentSelected(
        selectedUserList: any[],
        departmentTag: string
    ): boolean {
        const orgUser = selectedUserList?.find((itineraryUser) => {
            if (itineraryUser.type === 'Department') {
                if (itineraryUser.option === departmentTag) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        })
        if (orgUser) {
            return true
        } else {
            return false
        }
    }

    function checkIfGroupSelected(
        selectedUserList: any[],
        groupTag: string
    ): boolean {
        const orgUser = selectedUserList?.find((itineraryUser) => {
            if (itineraryUser.type === 'Group') {
                if (itineraryUser.option === groupTag) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        })
        if (orgUser) {
            return true
        } else {
            return false
        }
    }

    const departmentLine = (
        index: number,
        selectedUserList: any[],
        inItinerary: boolean,
        tag: TOrgTag
    ) => {
        return (
            <div
                key={tag.name}
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'auto auto 1fr',
                    alignItems: 'center',
                    width: '100%',
                    gap: '8px',
                }}
                onClick={() => {
                    try {
                        var tmp
                        if (inItinerary) {
                            const tmpMembersListTemp = selectedUserList.filter(
                                (member) => {
                                    if (
                                        member.type === 'Department' &&
                                        member.option === tag.name
                                    ) {
                                        return false
                                    } else {
                                        return true
                                    }
                                }
                            )
                            tmp = JSON.parse(membersListSelectList)
                            tmp[index].users = tmpMembersListTemp

                            setMembersListSelectList(JSON.stringify(tmp))
                        } else {
                            tmp = JSON.parse(membersListSelectList)
                            tmp[index].users = [
                                ...JSON.parse(membersListSelectList)[index]
                                    .users,
                                { type: 'Department', option: tag.name },
                            ]
                            setMembersListSelectList(JSON.stringify(tmp))
                        }
                    } catch {}
                }}
            >
                <Box>
                    <Checkbox checked={inItinerary} color="secondary" />
                </Box>

                <Box>
                    <Icon
                        name="Users"
                        height="32px"
                        width="32px"
                        bubble
                        bubbleColour={tag.color}
                    />
                </Box>

                <Box>
                    <Typography>{tag.name}</Typography>
                </Box>
            </div>
        )
    }

    type GroupLineProps = {
        listIndex: number
        selectedUserList: any[]
        inItinerary: boolean
        tag: TOrgTag
        index: number
    }

    const GroupLine: FC<GroupLineProps> = ({
        listIndex,
        selectedUserList,
        inItinerary,
        tag,
        index,
    }) => {
        return (
            <div
                key={tag.name + index}
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'auto auto 1fr',
                    alignItems: 'center',
                    width: '100%',
                    gap: '8px',
                }}
                onClick={() => {
                    try {
                        if (inItinerary) {
                            const tmpMembersListTemp = selectedUserList.filter(
                                (member) => {
                                    if (
                                        member.type === 'Group' &&
                                        member.option === tag.name
                                    ) {
                                        return false
                                    } else {
                                        return true
                                    }
                                }
                            )
                            var tmp = JSON.parse(membersListSelectList)
                            tmp[listIndex].users = tmpMembersListTemp

                            setMembersListSelectList(JSON.stringify(tmp))
                        } else {
                            var tmp = JSON.parse(membersListSelectList)
                            tmp[listIndex].users = [
                                ...JSON.parse(membersListSelectList)[listIndex]
                                    .users,
                                { type: 'Group', option: tag.name },
                            ]

                            setMembersListSelectList(JSON.stringify(tmp))
                        }
                    } catch {}
                }}
            >
                <Box>
                    <Checkbox
                        checked={inItinerary}
                        color="secondary"
                        key={index + 'key'}
                    />
                </Box>
                <Box>
                    <Icon
                        name="Users"
                        height="32px"
                        width="32px"
                        bubble
                        bubbleColour={tag.color}
                    />
                </Box>

                <Box>
                    <Typography>{tag.name}</Typography>
                </Box>
            </div>
        )
    }

    const departmentsListSection = (selectedUserList, listIndex) => {
        if (orgConfig && orgConfig?.departmentTags) {
            return orgConfig?.departmentTags?.map((depTag) => {
                return departmentLine(
                    listIndex,
                    selectedUserList,
                    checkIfDepartmentSelected(selectedUserList, depTag.name),
                    depTag
                )
            })
        } else {
            return null
        }
    }

    const groupsListSection = (selectedUserList, listIndex) => {
        if (orgConfig && orgConfig?.groupTags) {
            return orgConfig.groupTags.map((groupTag, index) => {
                return (
                    <GroupLine
                        listIndex={listIndex}
                        selectedUserList={selectedUserList}
                        inItinerary={checkIfGroupSelected(
                            selectedUserList,
                            groupTag.name
                        )}
                        tag={groupTag}
                        index={index}
                    />
                )
            })
        } else {
            return null
        }
    }

    const UsersListSection = (selectedUserList: any[], listIndex: number) => {
        return (
            <>
                {selectedItineraryUsers().map((orgUser) => {
                    return (
                        <EditTeamMemberLine
                            index={listIndex}
                            selectedUserList={selectedUserList}
                            user={orgUser}
                            inList={checkIfUserSelected(
                                selectedUserList,
                                orgUser.id
                            )}
                        />
                    )
                })}
            </>
        )
    }

    type MembersListSectionProps = {
        selectedUserList: any
        listIndex: number
    }

    const MembersListSection: FC<MembersListSectionProps> = ({
        selectedUserList,
        listIndex,
    }) => {
        try {
            return (
                <>
                    {departmentsListSection(selectedUserList, listIndex)}
                    {groupsListSection(selectedUserList, listIndex)}
                    {UsersListSection(selectedUserList, listIndex)}
                </>
            )
        } catch {
            return null
        }
    }

    return (
        <Stack spacing={'16px'}>
            <Box
                borderRadius={'8px'}
                height={'56px'}
                bgcolor={ColoursObj.shades.shade4}
            >
                <Stack padding={'16px'} direction={'row'} spacing={'8px'}>
                    <Icon name={'Users'} />
                    <Typography variant="bodyBold">
                        {i18n.t('general.attendees')}
                    </Typography>
                </Stack>
            </Box>
            <MainButton
                text="Add Attendee"
                icon="Add"
                iconPosition="left"
                onClick={() => {
                    setMembersListSelectList(
                        JSON.stringify([
                            ...JSON.parse(membersListSelectList),
                            { users: [] },
                        ])
                    )
                }}
            />
            {(JSON.parse(membersListSelectList) as any[]).map(
                (attendeesList: any, index) => {
                    return (
                        <Box
                            key={index}
                            sx={{
                                display: 'grid',
                                gap: '8px',
                            }}
                        >
                            <Box>
                                <Typography>Attendee Set</Typography>
                            </Box>
                            <MembersListSection
                                selectedUserList={attendeesList.users}
                                listIndex={index}
                            />
                        </Box>
                    )
                }
            )}
        </Stack>
    )
}
